module.exports = __webpack_public_path__ + "static/media/mainHkas.2c982fce.png";